module.exports = __webpack_public_path__ + "media/images/hero-mobile-3-2af2a6d3b205204f2b24384b90284759.jpg";